import axios from 'axios';

export interface cancelWaitJoinProps {
    accountId: string,
    paramId: string,
    eventUrl: string,
    rotaryCd: string
}

/**
 * イベント参加情報　キャンセル待ち参加登録をするAPIを呼び出す関数
 */
export async function setCancelWaitJoin(props: cancelWaitJoinProps): Promise<any> {
    try{
        const response = await axios.put(process.env.REACT_APP_PATH + `/users/me/event/cancelwait/join`, null, {
            params: {
                accountId: props.accountId,
                paramId: props.paramId,
                url: props.eventUrl,
                rotaryCd: props.rotaryCd
            },
            paramsSerializer:{
              indexes: null
            }
        });
        return JSON.parse(JSON.stringify(response.data[0]));

    }catch(err){
        console.error(err);
    }
}